var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alpheios-wordlist-filters" }, [
    _c("p", { staticClass: "alpheios-wordlist-header-title" }, [
      _vm._v(_vm._s(_vm.l10n.getText("WORDLIST_FILTER_BY"))),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticClass: "alpheios-wordlist-header-select-filterBy-first" },
        [
          _c(
            "div",
            { staticClass: "alpheios-wordlist-header-select-filterBy-block" },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedFilterBy,
                      expression: "selectedFilterBy",
                    },
                  ],
                  staticClass:
                    "alpheios-select alpheios-wordlist-header-select-filterBy",
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedFilterBy = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.changedFilterBy,
                    ],
                  },
                },
                _vm._l(_vm.typeFiltersList, function (typeFiltering) {
                  return _c(
                    "option",
                    {
                      key: typeFiltering.value,
                      class: {
                        "alpheios-select-disabled-option": !typeFiltering.value,
                      },
                      domProps: { value: typeFiltering.value },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.calcTitle(typeFiltering, "selectedFilterBy"))
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _vm.currentClickedLemma &&
          _vm.currentTypeFilter &&
          (_vm.currentTypeFilter.showTextInput ||
            _vm.currentTypeFilter.showNumberInput)
            ? _c(
                "div",
                {
                  staticClass: "alpheios-wordlist-header-input-filterBy-block",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "alpheios-select-input-group",
                      class: {
                        "alpheios-select-input-group-show-select":
                          _vm.shownVariantsSelect,
                      },
                    },
                    [
                      _vm.currentTypeFilter.showTextInput
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.textInput,
                                expression: "textInput",
                              },
                            ],
                            staticClass:
                              "alpheios-input alpheios-wordlist-header-input-filterBy",
                            attrs: {
                              placeholder:
                                _vm.currentTypeFilter.textInputPlaceholder,
                              autocapitalize: "off",
                              autocorrect: "off",
                            },
                            domProps: { value: _vm.textInput },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.clickFilterBy.apply(null, arguments)
                              },
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.textInput = $event.target.value
                                },
                                _vm.filterVariants,
                              ],
                              focus: _vm.filterVariants,
                              blur: _vm.hideAutocomplete,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedFilterBy === "byExactForm"
                        ? _c(
                            "ul",
                            { staticClass: "alpheios-select-list" },
                            _vm._l(
                              _vm.wordExactFormsFiltered,
                              function (exactForm, exactFormIndex) {
                                return _c("li", {
                                  key: exactFormIndex,
                                  domProps: { innerHTML: _vm._s(exactForm) },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectExactForm(exactForm)
                                    },
                                  },
                                })
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedFilterBy === "byLemma"
                        ? _c(
                            "ul",
                            { staticClass: "alpheios-select-list" },
                            _vm._l(
                              _vm.wordLemmaFormsFiltered,
                              function (lemmaForm, lemmaFormIndex) {
                                return _c("li", {
                                  key: lemmaFormIndex,
                                  domProps: { innerHTML: _vm._s(lemmaForm) },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectLemmaForm(lemmaForm)
                                    },
                                  },
                                })
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTypeFilter.showNumberInput
                        ? _c("div", { staticClass: "alpheios-number-input" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filterAmount,
                                  expression: "filterAmount",
                                },
                              ],
                              staticClass:
                                "alpheios-input alpheios-wordlist-header-input-filterBy",
                              attrs: {
                                type: "number",
                                min: _vm.wordlistFilterAmountDefault.minValue,
                                max: _vm.wordlistFilterAmountDefault.maxValue,
                              },
                              domProps: { value: _vm.filterAmount },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.filterAmount = $event.target.value
                                  },
                                  _vm.changeFilterAmount,
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "alpheios-number-input-description",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.currentTypeFilter.textInputPlaceholder
                                  )
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }